import React, { FC } from 'react'
import * as Sentry from '@sentry/react'

type ErrorBoundaryProps = {
  children: React.ReactNode,
}

const ErrorBoundary: FC<React.PropsWithChildren<ErrorBoundaryProps>> = ({
  children,
}) => {
  return (
    <Sentry.ErrorBoundary
      showDialog
      fallback={
        <div>
          <h4>Something went wrong:</h4>
        </div>
      }
    >
      { children }
    </Sentry.ErrorBoundary>
  )
}

export default ErrorBoundary